module.exports = __webpack_public_path__ + "img/10050003.2b8d6138.jpg";